// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import {
//    Button,
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    FormErrorMessage,
//    ModalCloseButton,
//    ModalBody,
//    ModalFooter,
//    FormControl,
//    FormLabel,
//    Input,
//    Select,
//    InputGroup,
//    InputRightElement,
//    useColorModeValue,
//    useDisclosure,
//    Checkbox,
//    GridItem,
//    Grid,
//    Text,
// } from '@chakra-ui/react';
// import { useDispatch, useSelector } from 'react-redux';
// import { addUser, getUser, updateUser, getUsers } from '../../../redux/actions/user';
// import ManageUserRoleForm from './ManageUserRoleForm';
// import { USER_TYPE_OPTIONS, USER_TYPES } from '../../../constants';
// import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
// import { getBrand } from '../../../redux/actions/brand';
// import { getCategory } from '../../../redux/actions/category';
// import { getSeries } from '../../../redux/actions/series';
// import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
// import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
// import { useGlobal, useUser } from '../../../contexts';

// const AddUserModal = ({
//    isOpen,
//    onClose,
//    isEditMode = false,
//    userId,
//    usertype,
//    companyList,
//    username,
//    onSave,
//    isOpenRoleModal = true,
// }) => {
//    const dispatch = useDispatch();
//    const mobileRef = useRef(null);
//    const emailRef = useRef(null);
//    const seriesRef = useRef(null);
//    const categoryRef = useRef(null);
//    const brandRef = useRef(null);
//    const userTypeRef = useRef(null);
//    const passwordRef = useRef(null);
//    const [formData, setFormData] = useState({
//       name: username || '',
//       mobile: '',
//       email: '',
//       password: '',
//       selectedUserType: [USER_TYPE_OPTIONS[usertype ? usertype : 0].id],
//       mobileAppAccess: false,
//       web2Factor: false,
//       brandIds: [],
//       categoryIds: [],
//       seriesIds: [],
//    });
//    const [errors, setErrors] = useState({
//       name: '',
//       mobile: '',
//       email: '',
//       password: '',
//    });
//    const [showPassword, setShowPassword] = useState(false);
//    const [isInitialized, setIsInitialized] = useState(false);

//    const textColor = useColorModeValue('#9E9E9E', 'white');
//    const { isOpen: isRoleModel, onOpen: onRoleModelOpen, onClose: onCloseRoleModel } = useDisclosure();

//    const {user} = useUser();
//    const { userGlobalSettingsData } = useGlobal();
//    const shouldSendCompanyidSeries = userGlobalSettingsData?.[0]?.askCompany?.series || false;
//    const shouldSendCompanyidCategory = userGlobalSettingsData?.[0]?.askCompany?.category || false;
//    const shouldSendCompanyidBrand = userGlobalSettingsData?.[0]?.askCompany?.brand || false;

//    const brandData = useSelector((state) => state.brand.list || []);
//    const categoryData = useSelector((state) => state.category.list || []);
//    const seriesData = useSelector((state) => state.series.list || []);
//    const userList = useSelector((state) => state.user?.list || []);
//    const isError = useSelector((state) => state.user.isError);

//    // Fetch initial data
//    useEffect(() => {
//       dispatch(getUser());
//       const fetchInitialData = async () => {
//          await dispatch(getBrand({ ...(shouldSendCompanyidBrand && { companyIds: user?.user?.loginhistory?.companyId }) }));
//          await dispatch(getCategory({ ...(shouldSendCompanyidCategory && { companyIds: user?.user?.loginhistory?.companyId }) }));
//          await dispatch(getSeries({ ...(shouldSendCompanyidSeries && { companyIds: user?.user?.loginhistory?.companyId }) }));
//          setIsInitialized(true);
//       };

//       if (isOpen && !isInitialized) {
//          fetchInitialData();
//       }
//    }, [dispatch, isOpen, isInitialized]);

//    // Initialize form for edit mode
//    useEffect(() => {
//       if (isEditMode && userId && isOpen && userList.length > 0 && isInitialized) {
//          const user = userList.find((user) => user.id === userId);
//          if (user) {
//             setFormData({
//                name: user.name || '',
//                mobile: user.mobile || '',
//                email: user.email || '',
//                password: '',
//                selectedUserType: user.type ?? user.userType ?? user.user_type ?? USER_TYPE_OPTIONS[0].id,
//                mobileAppAccess: user.mobileAppAccess || false,
//                web2Factor: user.web2Factor || false,
//                brandIds: user.brandIds || [],
//                categoryIds: user.categoryIds || [],
//                seriesIds: user.seriesIds || [],
//             });
//          }
//       }
//    }, [isEditMode, userId, userList, isOpen, isInitialized]);

//    // Reset form when closing modal
//    const resetForm = useCallback(() => {
//       setFormData({
//          name: username || '',
//          mobile: '',
//          email: '',
//          password: '',
//          selectedUserType: [USER_TYPE_OPTIONS[usertype ? usertype : 0].id],
//          mobileAppAccess: false,
//          web2Factor: false,
//          brandIds: [],
//          categoryIds: [],
//          seriesIds: [],
//       });
//       setErrors({
//          name: '',
//          mobile: '',
//          email: '',
//          password: '',
//       });
//       setIsInitialized(false);
//    }, [username, usertype]);

//    useEffect(() => {
//       if (!isOpen) {
//          resetForm();
//       }
//    }, [isOpen, resetForm]);

//    const handleInputChange = (field, value) => {
//       setFormData((prev) => ({ ...prev, [field]: value }));

//       // Validation
//       if (field === 'name') {
//          setErrors((prev) => ({
//             ...prev,
//             name: value.length >= 1 ? '' : 'Name should be atleast 1 letter ',
//          }));
//       } else if (field === 'mobile') {
//          const isValid = /^\d{10}$/.test(value);
//          setErrors((prev) => ({
//             ...prev,
//             mobile: isValid ? '' : 'Mobile should be 10 digits',
//          }));
//       } else if (field === 'email') {
//          const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
//          setErrors((prev) => ({
//             ...prev,
//             email: isValid ? '' : 'Invalid email format',
//          }));
//       } else if (field === 'password' && !isEditMode) {
//          setErrors((prev) => ({
//             ...prev,
//             password: value.length >= 8 ? '' : 'Password must be at least 8 characters',
//          }));
//       }
//    };

//    const handleBrandChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, brandIds: selectedValues || [] }));
//    };

//    const handleUserTypeChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, selectedUserType: selectedValues || [] }));
//    };

//    const handleCategoryChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, categoryIds: selectedValues || [] }));
//    };

//    const handleSeriesChange = (selectedValues) => {
//       setFormData((prev) => ({ ...prev, seriesIds: selectedValues || [] }));
//    };

//    const validateForm = () => {
//       const newErrors = { ...errors };

//       if (!formData.name.trim()) {
//          newErrors.name = 'Name is required';
//       }

//       if (!formData.mobile.trim()) {
//          newErrors.mobile = 'Mobile is required';
//       }

//       if (!formData.email.trim()) {
//          newErrors.email = 'Email is required';
//       }

//       if (!isEditMode && !formData.password.trim()) {
//          newErrors.password = 'Password is required';
//       }

//       setErrors(newErrors);
//       return !Object.values(newErrors).some((error) => error);
//    };

//    const handleSubmit = async (e) => {
//       e.preventDefault();

//       if (!validateForm()) return;

//       const userData = {
//          name: formData.name,
//          mobile: formData.mobile,
//          email: formData.email,
//          type: formData.selectedUserType.length > 0 ? formData.selectedUserType : [USER_TYPE_OPTIONS[0].id],
//          mobileAppAccess: formData.mobileAppAccess,
//          web2Factor: formData.web2Factor,
//          brandIds: formData.brandIds,
//          categoryIds: formData.categoryIds,
//          seriesIds: formData.seriesIds,
//          ...(!isEditMode && { password: formData.password }),
//       };

//       try {
//          let res;
//          if (isEditMode) {
//             const editUser = userList.find((user) => user.id === userId);
//             if (editUser) {
//                res = await dispatch(
//                   updateUser({
//                      id: editUser.id,
//                      ...userData,
//                   }),
//                );
//             }
//          } else {
//             res = await dispatch(addUser(userData));
//          }

//          if (res?.code === 1) {
//             // Refresh all necessary data after successful operation
//             await Promise.all([
//                dispatch(getUsers({ userType: USER_TYPES.SALESMAN })),
//                dispatch(getUser()),
//                dispatch(getBrand()),
//                dispatch(getCategory()),
//                dispatch(getSeries()),
//             ]);

//             if (!isEditMode && isOpenRoleModal) {
//                onRoleModelOpen();
//             }

//             if (typeof onSave === 'function') {
//                onSave(res.data);
//             }

//             if (typeof onClose === 'function') {
//                onClose();
//             }
//          }
//       } catch (error) {
//          console.error('Error in handleSubmit:', error);
//       }
//    };

//    const isFormValid =
//       !Object.values(errors).some((error) => error) &&
//       formData.name &&
//       formData.mobile &&
//       formData.email &&
//       (isEditMode || formData.password);

//    return (
//       <>
//          <Modal isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={false} size={'xl'}>
//             <ModalOverlay />
//             <ModalContent>
//                <ModalHeader>{isEditMode ? 'Edit User' : 'Add New User'}</ModalHeader>
//                <ModalCloseButton />
//                <ModalBody>
//                   {/* First row with two fields */}
//                   <Grid templateColumns="repeat(2, 1fr)" gap={4} mb={4}>
//                      <GridItem>
//                         {DynamicInput(
//                            'name',
//                            'Name',
//                            {
//                               value: formData.name,
//                               onChange: (e) => handleInputChange('name', e.target.value),
//                               onKeyDown: (e) => {
//                                  if (e.key === 'Enter') {
//                                     e.preventDefault();
//                                     mobileRef.current?.focus();
//                                  }
//                               },
//                            },
//                            errors,
//                            textColor,
//                            'text',
//                            true,
//                         )}
//                      </GridItem>

//                      <GridItem>
//                         {DynamicInput(
//                            'mobile',
//                            'Mobile',
//                            {
//                               value: formData.mobile,
//                               onChange: (e) => handleInputChange('mobile', e.target.value),
//                               ref: mobileRef,
//                               onKeyDown: (e) => {
//                                  if (e.key === 'Enter') {
//                                     e.preventDefault();
//                                     emailRef.current?.focus();
//                                  }
//                               },
//                            },
//                            errors,
//                            textColor,
//                            'number',
//                            false,
//                         )}
//                      </GridItem>
//                   </Grid>

//                   {/* Second row with two fields */}
//                   <Grid templateColumns="repeat(2, 1fr)" gap={4} mb={4}>
//                      <GridItem>
//                         {DynamicInput(
//                            'email',
//                            'Email',
//                            {
//                               value: formData.email,
//                               onChange: (e) => handleInputChange('email', e.target.value),
//                               ref: emailRef,
//                               onKeyDown: (e) => {
//                                  if (e.key === 'Enter') {
//                                     e.preventDefault();
//                                     passwordRef.current?.focus();
//                                  }
//                               },
//                               disabled: isEditMode,
//                            },
//                            errors,
//                            textColor,
//                            'email',
//                            false,
//                         )}
//                      </GridItem>

//                      {!isEditMode && (
//                         <GridItem className="seperator-width">
//                            <FormControl>
//                               <InputGroup>
//                                  <Input
//                                     name="password"
//                                     ref={passwordRef}
//                                     placeholder="Password"
//                                     value={formData.password}
//                                     onChange={(e) => handleInputChange('password', e.target.value)}
//                                     type={showPassword ? 'text' : 'password'}
//                                     onKeyDown={(e) => {
//                                        if (e.key === 'Enter') {
//                                           e.preventDefault();
//                                           userTypeRef.current?.focus();
//                                        }
//                                     }}
//                                     pr="4.5rem"
//                                     focusBorderColor={errors.password ? 'red.500' : 'green.500'}
//                                     borderColor={errors.password ? 'red.500' : 'gray.200'}
//                                  />
//                                  <InputRightElement width="4.5rem">
//                                     <Button
//                                        h="1.75rem"
//                                        size="sm"
//                                        onClick={() => setShowPassword(!showPassword)}
//                                        variant="ghost"
//                                        colorScheme="gray">
//                                        {showPassword ? <ViewOffIcon /> : <ViewIcon />}
//                                     </Button>
//                                  </InputRightElement>
//                               </InputGroup>
//                               {errors.password && (
//                                  <Text color="red.500" fontSize="sm" mt={1}>
//                                     {errors.password}
//                                  </Text>
//                               )}
//                            </FormControl>
//                         </GridItem>
//                      )}
//                   </Grid>
//                   {/* <Grid templateColumns="repeat(1, 1fr)" gap={4} mb={4}>
//                      <GridItem className="seperator-width" mt={5} w="45%" mr="5%">
//                         {renderDynamicDropdown(
//                            'userType',
//                            'User Type',
//                            USER_TYPE_OPTIONS,
//                            {
//                               value: formData.selectedUserType,
//                               onChange: (e) => { handleInputChange('selectedUserType', e.target.value) },
//                            },
//                            {},
//                            textColor,
//                            false,
//                            'Select Transaction Type',
//                            true,
//                            undefined,
//                            true,
//                         )}
//                      </GridItem>
//                   </Grid> */}

//                   {/* Single column items */}
//                   <FormControl mt={4}>
//                      {/* <FormLabel>User Type</FormLabel> */}
//                      <GridItem className="seperator-width" mt={5} w="100%" mr="5%">
//                         {renderDynamicDropdown(
//                            'userType',
//                            'User Type',
//                            USER_TYPE_OPTIONS,
//                            {
//                               value: formData.selectedUserType,
//                               onChange: handleUserTypeChange,
//                            },
//                            {},
//                            textColor,
//                            false,
//                            'Select Transaction Type',
//                            true,
//                            undefined,
//                            true,
//                         )}
//                      </GridItem>
//                   </FormControl>
//                   <Grid templateColumns="repeat(2, 1fr)" gap={4} mt={4}>
//                      <FormControl>
//                         <Checkbox
//                            isChecked={formData.mobileAppAccess}
//                            onChange={(e) => handleInputChange('mobileAppAccess', e.target.checked)}>
//                            Allow Mobile App Access
//                         </Checkbox>
//                      </FormControl>

//                      <FormControl>
//                         <Checkbox
//                            isChecked={formData.web2Factor}
//                            onChange={(e) => handleInputChange('web2Factor', e.target.checked)}>
//                            2 step verification on login
//                         </Checkbox>
//                      </FormControl>
//                   </Grid>

//                   {/* Dropdowns */}
//                   <Grid templateColumns="repeat(2, 1fr)" gap={4} mt={4}>
//                      <FormControl>
//                         {renderDynamicDropdown(
//                            'brandid',
//                            'Brand',
//                            brandData,
//                            {
//                               value: formData.brandIds,
//                               onChange: handleBrandChange,
//                               ref: brandRef,
//                               showCustomNoOptions: true,
//                               openfrom: 'brand',
//                               onKeyDown: (e) => {
//                                  if (e.key === 'Enter') {
//                                     e.preventDefault();
//                                     categoryRef.current?.focus();
//                                  }
//                               },
//                            },
//                            errors,
//                            textColor,
//                            true,
//                            'Select Brand',
//                            true,
//                            undefined,
//                            true,
//                         )}
//                      </FormControl>

//                      <FormControl>
//                         {renderDynamicDropdown(
//                            'categoryid',
//                            'Category',
//                            categoryData,
//                            {
//                               value: formData.categoryIds,
//                               onChange: handleCategoryChange,
//                               ref: categoryRef,
//                               showCustomNoOptions: true,
//                               openfrom: 'category',
//                               onKeyDown: (e) => {
//                                  if (e.key === 'Enter') {
//                                     e.preventDefault();
//                                     seriesRef.current?.focus();
//                                  }
//                               },
//                            },
//                            errors,
//                            textColor,
//                            true,
//                            'Select Category',
//                            true,
//                            undefined,
//                            true,
//                         )}
//                      </FormControl>
//                   </Grid>

//                   <FormControl mt={4}>
//                      {renderDynamicDropdown(
//                         'seriesId',
//                         'Series',
//                         seriesData,
//                         {
//                            value: formData.seriesIds,
//                            onChange: handleSeriesChange,
//                            ref: seriesRef,
//                            showCustomNoOptions: true,
//                            openfrom: 'series',
//                            // onKeyDown: (e) => {
//                            //    if (e.key === 'Enter') {
//                            //       e.preventDefault();
//                            //       categoryRef.current?.focus();
//                            //    }
//                            // },
//                         },
//                         errors,
//                         textColor,
//                         true,
//                         'Select Series',
//                         true,
//                         undefined,
//                         true,
//                      )}
//                   </FormControl>
//                </ModalBody>
//                <ModalFooter>
//                   <Button colorScheme="green" variant="ghost" mr={3} onClick={onClose}>
//                      Cancel
//                   </Button>
//                   <Button colorScheme="green" onClick={handleSubmit} isDisabled={!isFormValid}>
//                      Save
//                   </Button>
//                </ModalFooter>
//             </ModalContent>
//          </Modal>

//          <ManageUserRoleForm isOpen={isRoleModel} onClose={onCloseRoleModel} companyList={companyList} />
//       </>
//    );
// };

// export default AddUserModal;

import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
   Button,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   FormErrorMessage,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   FormControl,
   FormLabel,
   Input,
   Select,
   InputGroup,
   InputRightElement,
   useColorMode,
   useDisclosure,
   Checkbox,
   GridItem,
   Grid,
   Text,
   Box,
   Divider,
   VStack,
   HStack,
   Switch,
   IconButton,
} from '@chakra-ui/react';
import { CopyIcon } from '@chakra-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { addUser, getUser, updateUser, getUsers } from '../../../redux/actions/user';
import ManageUserRoleForm from './ManageUserRoleForm';
import { USER_TYPE_OPTIONS, USER_TYPES } from '../../../constants';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { getBrand } from '../../../redux/actions/brand';
import { getCategory } from '../../../redux/actions/category';
import { getSeries } from '../../../redux/actions/series';
import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { useGlobal, useUser } from '../../../contexts';

const AddUserModal = ({
   isOpen,
   onClose,
   isEditMode = false,
   userId,
   usertype,
   companyList,
   username,
   onSave,
   isOpenRoleModal = true,
}) => {
   const dispatch = useDispatch();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const businessType = localStorage.getItem('businessTypes');
   const mobile = businessType === 'MOBILE';

   const mobileRef = useRef(null);
   const emailRef = useRef(null);
   const seriesRef = useRef(null);
   const categoryRef = useRef(null);
   const brandRef = useRef(null);
   const userTypeRef = useRef(null);
   const passwordRef = useRef(null);

   const [formData, setFormData] = useState({
      name: '',
      mobile: '',
      email: '',
      password: '',
      selectedUserType: [USER_TYPE_OPTIONS[usertype ? usertype : 0].id],
      mobileAppAccess: false,
      isSalesPrice: false,
      isShowSalesPrice: false,
      isDealerPrice: false,
      isShowDealerPrice: false,
      getSpOtp: false,
      web2Factor: false,
      brandIds: [],
      categoryIds: [],
      seriesIds: [],
   });

   const [errors, setErrors] = useState({
      // name: '',
      mobile: '',
      email: '',
      password: '',
   });

   const [showPassword, setShowPassword] = useState(false);
   const [isInitialized, setIsInitialized] = useState(false);

   const { isOpen: isRoleModel, onOpen: onRoleModelOpen, onClose: onCloseRoleModel } = useDisclosure();

   const { user } = useUser();
   const { userGlobalSettingsData } = useGlobal();
   const shouldSendCompanyidSeries = userGlobalSettingsData?.[0]?.askCompany?.series || false;
   const shouldSendCompanyidCategory = userGlobalSettingsData?.[0]?.askCompany?.category || false;
   const shouldSendCompanyidBrand = userGlobalSettingsData?.[0]?.askCompany?.brand || false;

   const brandData = useSelector((state) => state.brand.list || []);
   const categoryData = useSelector((state) => state.category.list || []);
   const seriesData = useSelector((state) => state.series.list || []);
   const userList = useSelector((state) => state.user?.list || []);
   const isError = useSelector((state) => state.user.isError);

   useEffect(() => {
      dispatch(getUser());
      const fetchInitialData = async () => {
         if (mobile) {
            await dispatch(
               getBrand({ ...(shouldSendCompanyidBrand && { companyIds: user?.user?.loginhistory?.companyId }) }),
            );
            await dispatch(
               getSeries({ ...(shouldSendCompanyidSeries && { companyIds: user?.user?.loginhistory?.companyId }) }),
            );
         }
         await dispatch(
            getCategory({ ...(shouldSendCompanyidCategory && { companyIds: user?.user?.loginhistory?.companyId }) }),
         );
         setIsInitialized(true);
      };

      if (isOpen && !isInitialized) {
         fetchInitialData();
      }
   }, [dispatch, isOpen, isInitialized]);

   useEffect(() => {
      if (isEditMode && userId && isOpen && userList.length > 0 && isInitialized) {
         const user = userList.find((user) => user.id === userId);
         if (user) {
            setFormData({
               name: user.email || '',
               mobile: user.mobile || '',
               email: user.email || '',
               password: '',
               selectedUserType: user.type ?? user.userType ?? user.user_type ?? USER_TYPE_OPTIONS[0].id,
               mobileAppAccess: user.mobileAppAccess || false,
               isSalesPrice: user.isSalesPrice || false,
               isShowSalesPrice: user.isShowSalesPrice || false,
               isDealerPrice: user.isDealerPrice || false,
               isShowDealerPrice: user.isShowDealerPrice || false,
               getSpOtp: user.getSpOtp || false,
               web2Factor: user.web2Factor || false,
               brandIds: user.brandIds || [],
               categoryIds: user.categoryIds || [],
               seriesIds: user.seriesIds || [],
            });
         }
      }
   }, [isEditMode, userId, userList, isOpen, isInitialized]);

   const resetForm = useCallback(() => {
      setFormData({
         name: '',
         mobile: '',
         email: '',
         password: '',
         selectedUserType: [USER_TYPE_OPTIONS[usertype ? usertype : 0].id],
         mobileAppAccess: false,
         isSalesPrice: false,
         isShowSalesPrice: false,
         isDealerPrice: false,
         isShowDealerPrice: false,
         getSpOtp: false,
         web2Factor: false,
         brandIds: [],
         categoryIds: [],
         seriesIds: [],
      });
      setErrors({
         // name: '',
         mobile: '',
         email: '',
         password: '',
      });
      setIsInitialized(false);
   }, [username, usertype]);

   useEffect(() => {
      if (!isOpen) {
         resetForm();
      }
   }, [isOpen, resetForm]);

   const handleInputChange = (field, value) => {
      setFormData((prev) => ({ ...prev, [field]: value }));

      // if (field === 'name') {
      //    setErrors((prev) => ({
      //       ...prev,
      //       name: value.length >= 1 ? '' : 'Name should be atleast 1 letter ',
      //    }));
      // } else
      if (field === 'mobile') {
         const isValid = /^\d{10}$/.test(value);
         setErrors((prev) => ({
            ...prev,
            mobile: isValid ? '' : 'Mobile should be 10 digits',
         }));
      } else if (field === 'email') {
         const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
         setErrors((prev) => ({
            ...prev,
            email: isValid ? '' : 'Invalid email format',
         }));
      } else if (field === 'password' && !isEditMode) {
         setErrors((prev) => ({
            ...prev,
            password: value.length >= 8 ? '' : 'Password must be at least 8 characters',
         }));
      }
   };

   const handleBrandChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, brandIds: selectedValues || [] }));
   };

   const handleUserTypeChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, selectedUserType: selectedValues || [] }));
   };

   const handleCategoryChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, categoryIds: selectedValues || [] }));
   };

   const handleSeriesChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, seriesIds: selectedValues || [] }));
   };

   const validateForm = () => {
      const newErrors = { ...errors };

      // if (!formData.name.trim()) {
      //    newErrors.name = 'Name is required';
      // }

      if (!formData.mobile.trim()) {
         newErrors.mobile = 'Mobile is required';
      }

      if (!formData.email.trim()) {
         newErrors.email = 'Email is required';
      }

      if (!isEditMode && !formData.password.trim()) {
         newErrors.password = 'Password is required';
      }

      setErrors(newErrors);
      return !Object.values(newErrors).some((error) => error);
   };

   const handleSubmit = async (e) => {
      e.preventDefault();

      if (!validateForm()) return;

      const userData = {
         name: formData.email,
         mobile: formData.mobile,
         email: formData.email,
         type: formData.selectedUserType.length > 0 ? formData.selectedUserType : [USER_TYPE_OPTIONS[0].id],
         mobileAppAccess: formData.mobileAppAccess,
         isSalesPrice: formData.isSalesPrice,
         isShowSalesPrice: formData.isShowSalesPrice,
         isDealerPrice: formData.isDealerPrice,
         isShowDealerPrice: formData.isShowDealerPrice,
         getSpOtp: formData.getSpOtp,
         web2Factor: formData.web2Factor,
         brandIds: formData.brandIds,
         categoryIds: formData.categoryIds,
         seriesIds: formData.seriesIds,
         ...(!isEditMode && { password: formData.password }),
      };

      try {
         let res;
         if (isEditMode) {
            const editUser = userList.find((user) => user.id === userId);
            if (editUser) {
               res = await dispatch(
                  updateUser({
                     id: editUser.id,
                     ...userData,
                  }),
               );
            }
         } else {
            res = await dispatch(addUser(userData));
         }

         if (res?.code === 1) {
            await Promise.all([
               dispatch(getUsers({ userType: USER_TYPES.SALESMAN })),
               dispatch(getUser()),
               ...(mobile ? [dispatch(getBrand())] : []),
               dispatch(getCategory()),
               ...(mobile ? [dispatch(getSeries())] : []),
            ]);

            if (!isEditMode && isOpenRoleModal) {
               onRoleModelOpen();
            }

            if (typeof onSave === 'function') {
               onSave(res.data);
            }

            if (typeof onClose === 'function') {
               onClose();
            }
         }
      } catch (error) {
         console.error('Error in handleSubmit:', error);
      }
   };

   const isFormValid =
      !Object.values(errors).some((error) => error) &&
      // formData.name &&
      formData.mobile &&
      formData.email &&
      (isEditMode || formData.password);

   return (
      <>
         <Modal isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={false} size={'2xl'}>
            <ModalOverlay bg={isDark ? 'rgba(0, 0, 0, 0.7)' : 'rgba(0, 0, 0, 0.4)'} backdropFilter="blur(10px)" />
            <ModalContent
               className={`
         ${isDark ? 'bg-slate-900' : 'bg-white'} 
         rounded-3xl shadow-2xl overflow-hidden border-0
      `}
               maxW="900px"
               maxH="90vh">
               {/* Modern Header with Gradient Accent */}
               <Box className={`relative ${isDark ? 'bg-slate-900' : 'bg-white'}`}>
                  <Box
                     className={`absolute top-0 left-0 right-0 h-1 ${isDark
                        ? 'bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500'
                        : 'bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400'
                        }`}></Box>
                  <ModalHeader
                     className={`${isDark ? 'text-white' : 'text-gray-900'} text-2xl font-bold pt-8 pb-2 px-8`}>
                     {isEditMode ? '✏️ Edit User' : '➕ Create New User'}
                  </ModalHeader>
                  <Text className={`${isDark ? 'text-gray-400' : 'text-gray-500'} text-sm px-8 pb-6`}>
                     {isEditMode
                        ? 'Update user information and settings'
                        : 'Add a new team member to your organization'}
                  </Text>
                  <ModalCloseButton
                     className={`${isDark ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-900'
                        } top-6 right-6`}
                  />
               </Box>

               <Divider className={isDark ? 'border-slate-700' : 'border-gray-200'} />

               <ModalBody
                  className={`${isDark ? 'bg-slate-900' : 'bg-gray-50'} px-8 py-8 space-y-6`}
                  maxH="calc(90vh - 220px)"
                  overflowY="auto"
                  css={{
                     '&::-webkit-scrollbar': {
                        width: '8px',
                     },
                     '&::-webkit-scrollbar-track': {
                        background: isDark ? '#1e293b' : '#f1f5f9',
                        borderRadius: '10px',
                     },
                     '&::-webkit-scrollbar-thumb': {
                        background: isDark ? '#475569' : '#cbd5e1',
                        borderRadius: '10px',
                     },
                     '&::-webkit-scrollbar-thumb:hover': {
                        background: isDark ? '#64748b' : '#94a3b8',
                     },
                  }}>
                  {/* Account Credentials Card */}
                  <Box
                     className={`
            ${isDark
                           ? 'bg-slate-800/50 border-2 border-slate-700 hover:border-slate-600'
                           : 'bg-white border-2 border-gray-200 hover:border-purple-300'
                        } 
            rounded-2xl px-6 py-3 transition-all duration-300 hover:shadow-lg
         `}>
                     <Text
                        className={`
               ${isDark ? 'text-purple-400' : 'text-purple-600'} 
               text-xs font-bold uppercase tracking-wider mb-4
            `}>
                        🔐 Account Credentials
                     </Text>
                     <Grid templateColumns="repeat(2, 1fr)" gap={5}>
                        <GridItem>
                           <InputGroup>
                              {DynamicInput(
                                 'email',
                                 'Email Address',
                                 {
                                    value: formData.email,
                                    onChange: (e) => handleInputChange('email', e.target.value),
                                    ref: emailRef,
                                    onKeyDown: (e) => {
                                       if (e.key === 'Enter') {
                                          e.preventDefault();
                                          passwordRef.current?.focus();
                                       }
                                    },
                                    disabled: isEditMode,
                                    pr: '40px',
                                 },
                                 errors,
                                 isDark ? '#94a3b8' : '#64748b',
                                 'email',
                                 false,
                              )}

                              <InputRightElement pointerEvents="auto">
                                 <IconButton
                                    aria-label="Copy email"
                                    icon={<CopyIcon />}
                                    size="sm"
                                    variant="ghost"
                                    isDisabled={!formData.email}
                                    onClick={() => navigator.clipboard.writeText(formData.email)}
                                 />
                              </InputRightElement>
                           </InputGroup>
                        </GridItem>
                        {!isEditMode && (
                           <GridItem>
                              <FormControl>
                                 <FormLabel
                                    className={`${isDark ? 'text-slate-300' : 'text-gray-700'
                                       } text-sm font-medium mb-2`}>
                                    Password
                                 </FormLabel>
                                 <InputGroup>
                                    <Input
                                       name="password"
                                       ref={passwordRef}
                                       placeholder="Enter password"
                                       value={formData.password}
                                       onChange={(e) => handleInputChange('password', e.target.value)}
                                       type={showPassword ? 'text' : 'password'}
                                       onKeyDown={(e) => {
                                          if (e.key === 'Enter') {
                                             e.preventDefault();
                                             userTypeRef.current?.focus();
                                          }
                                       }}
                                       pr="4.5rem"
                                       className={`
                                 ${isDark
                                             ? 'bg-slate-900 border-slate-600 text-white focus:border-purple-500'
                                             : 'bg-gray-50 border-gray-300 text-gray-900 focus:border-purple-500'
                                          }
                                 ${errors.password ? 'border-red-500' : ''}
                              `}
                                       focusBorderColor={errors.password ? 'red.500' : 'purple.500'}
                                    />
                                    <InputRightElement width="4.5rem">
                                       <Button
                                          h="1.75rem"
                                          size="sm"
                                          onClick={() => setShowPassword(!showPassword)}
                                          variant="ghost"
                                          className={
                                             isDark
                                                ? 'text-slate-400 hover:text-white'
                                                : 'text-gray-600 hover:text-gray-900'
                                          }>
                                          {showPassword ? <ViewOffIcon /> : <ViewIcon />}
                                       </Button>
                                    </InputRightElement>
                                 </InputGroup>
                                 {errors.password && (
                                    <Text color="red.500" fontSize="sm" mt={1}>
                                       {errors.password}
                                    </Text>
                                 )}
                              </FormControl>
                           </GridItem>
                        )}
                     </Grid>
                  </Box>

                  {/* Personal Info Card */}
                  <Box
                     className={`
            ${isDark
                           ? 'bg-slate-800/50 border-2 border-slate-700 hover:border-slate-600'
                           : 'bg-white border-2 border-gray-200 hover:border-blue-300'
                        } 
            rounded-2xl px-6 py-3 transition-all duration-300 hover:shadow-lg
         `}>
                     <Text
                        className={`
               ${isDark ? 'text-blue-400' : 'text-blue-600'} 
               text-xs font-bold uppercase tracking-wider mb-4
            `}>
                        👤 Personal Information
                     </Text>
                     <Grid templateColumns="repeat(1, 1fr)" gap={5}>
                        <GridItem>
                           {DynamicInput(
                              'mobile',
                              'Mobile Number',
                              {
                                 value: formData.mobile,
                                 onChange: (e) => handleInputChange('mobile', e.target.value),
                                 ref: mobileRef,
                                 onKeyDown: (e) => {
                                    if (e.key === 'Enter') {
                                       e.preventDefault();
                                       emailRef.current?.focus();
                                    }
                                 },
                              },
                              errors,
                              isDark ? '#94a3b8' : '#64748b',
                              'number',
                              false,
                           )}
                        </GridItem>
                     </Grid>
                  </Box>

                  {/* Role & Permissions Card */}
                  <Box
                     className={`
            ${isDark
                           ? 'bg-slate-800/50 border-2 border-slate-700 hover:border-slate-600'
                           : 'bg-white border-2 border-gray-200 hover:border-green-300'
                        } 
            rounded-2xl px-6 py-3 transition-all duration-300 hover:shadow-lg
         `}>
                     <Text
                        className={`
               ${isDark ? 'text-green-400' : 'text-green-600'} 
               text-xs font-bold uppercase tracking-wider mb-4
            `}>
                        ⚙️ Role & Permissions
                     </Text>
                     <FormControl mb={4}>
                        {renderDynamicDropdown(
                           'userType',
                           'User Type',
                           USER_TYPE_OPTIONS,
                           {
                              value: formData.selectedUserType,
                              onChange: handleUserTypeChange,
                           },
                           {},
                           isDark ? '#94a3b8' : '#64748b',
                           false,
                           'Select User Type',
                           true,
                           undefined,
                           true,
                        )}
                     </FormControl>
                     {(user?.packageData?.[0]?.isMobileApp || user?.packageData?.[0]?.is2stepVerify) && (
                        <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                           {user?.packageData?.[0]?.isMobileApp && (
                              <Box
                                 className={`
                  ${isDark
                                       ? 'bg-slate-900/50 border border-slate-700 hover:bg-slate-900'
                                       : 'bg-gray-50 border border-gray-200 hover:bg-gray-100'
                                    } 
                  rounded-xl p-4 transition-all duration-200
               `}>
                                 <Checkbox
                                    isChecked={formData.mobileAppAccess}
                                    onChange={(e) => handleInputChange('mobileAppAccess', e.target.checked)}
                                    colorScheme="green"
                                    className={isDark ? 'text-slate-300' : 'text-gray-700'}>
                                    📱 Mobile App Access
                                 </Checkbox>
                              </Box>
                           )}
                           {user?.packageData?.[0]?.is2stepVerify && (
                              <Box
                                 className={`
                  ${isDark
                                       ? 'bg-slate-900/50 border border-slate-700 hover:bg-slate-900'
                                       : 'bg-gray-50 border border-gray-200 hover:bg-gray-100'
                                    } 
                  rounded-xl p-4 transition-all duration-200
               `}>
                                 <Checkbox
                                    isChecked={formData.web2Factor}
                                    onChange={(e) => handleInputChange('web2Factor', e.target.checked)}
                                    colorScheme="green"
                                    className={isDark ? 'text-slate-300' : 'text-gray-700'}>
                                    🔒 2-Step Verification
                                 </Checkbox>
                              </Box>
                           )}
                        </Grid>
                     )}
                     <Grid templateColumns="repeat(2, 1fr)" gap={4} mt={2}>
                        <Box
                           className={`${isDark
                              ? 'bg-slate-900/50 border border-slate-700 hover:bg-slate-900'
                              : 'bg-gray-50 border border-gray-200 hover:bg-gray-100'
                              } rounded-xl p-4 transition-all duration-200`}>
                           <Checkbox
                              isChecked={formData.isSalesPrice}
                              onChange={(e) => handleInputChange('isSalesPrice', e.target.checked)}
                              colorScheme="green"
                              className={isDark ? 'text-slate-300' : 'text-gray-700'}>
                              💰 Sales Price
                           </Checkbox>
                        </Box>
                        <Box
                           className={`${isDark
                              ? 'bg-slate-900/50 border border-slate-700 hover:bg-slate-900'
                              : 'bg-gray-50 border border-gray-200 hover:bg-gray-100'
                              } rounded-xl p-4 transition-all duration-200`}>
                           <Checkbox
                              isChecked={formData.isShowSalesPrice}
                              onChange={(e) => handleInputChange('isShowSalesPrice', e.target.checked)}
                              colorScheme="green"
                              className={isDark ? 'text-slate-300' : 'text-gray-700'}>
                              👁️💰 Show Sales Price
                           </Checkbox>
                        </Box>
                     </Grid>
                     <Grid templateColumns="repeat(2, 1fr)" gap={4} mt={2}>
                        <Box
                           className={`${isDark
                              ? 'bg-slate-900/50 border border-slate-700 hover:bg-slate-900'
                              : 'bg-gray-50 border border-gray-200 hover:bg-gray-100'
                              } rounded-xl p-4 transition-all duration-200`}>
                           <Checkbox
                              isChecked={formData.isDealerPrice}
                              onChange={(e) => handleInputChange('isDealerPrice', e.target.checked)}
                              colorScheme="green"
                              className={isDark ? 'text-slate-300' : 'text-gray-700'}>
                              🏷️ Dealer Price
                           </Checkbox>
                        </Box>
                        <Box
                           className={`${isDark
                              ? 'bg-slate-900/50 border border-slate-700 hover:bg-slate-900'
                              : 'bg-gray-50 border border-gray-200 hover:bg-gray-100'
                              } rounded-xl p-4 transition-all duration-200`}>
                           <Checkbox
                              isChecked={formData.isShowDealerPrice}
                              onChange={(e) => handleInputChange('isShowDealerPrice', e.target.checked)}
                              colorScheme="green"
                              className={isDark ? 'text-slate-300' : 'text-gray-700'}>
                              👁️🏷️ Show Dealer Price
                           </Checkbox>
                        </Box>
                     </Grid>
                     <Grid mt={4}>
                        <GridItem>
                           <Box border="1px solid" borderColor="gray.200" borderRadius="md" p={4}>
                              <HStack justify="space-between" align="center">
                                 <VStack align="start" spacing={0}>
                                    <Text fontWeight="semibold">Eligible for Sales OTP Verification</Text>
                                    <Text fontSize="sm" color="gray.500">
                                       Applies if sales item price is greater than purchase item price
                                    </Text>
                                 </VStack>

                                 <Switch
                                    isChecked={formData.getSpOtp}
                                    onChange={(e) => handleInputChange('getSpOtp', e.target.checked)}
                                 />
                              </HStack>
                           </Box>
                        </GridItem>
                     </Grid>
                  </Box>

                  {/* Company Settings Card */}
                  <Box
                     className={`
            ${isDark
                           ? 'bg-slate-800/50 border-2 border-slate-700 hover:border-slate-600'
                           : 'bg-white border-2 border-gray-200 hover:border-orange-300'
                        } 
            rounded-2xl px-6 py-3 transition-all duration-300 hover:shadow-lg
         `}>
                     <Text
                        className={`
               ${isDark ? 'text-orange-400' : 'text-orange-600'} 
               text-xs font-bold uppercase tracking-wider mb-4
            `}>
                        🏢 Company Configuration
                     </Text>
                     <Grid templateColumns="repeat(2, 1fr)" gap={5} mb={4}>
                        <FormControl>
                           {renderDynamicDropdown(
                              'brandid',
                              'Brand',
                              brandData,
                              {
                                 value: formData.brandIds,
                                 onChange: handleBrandChange,
                                 ref: brandRef,
                                 showCustomNoOptions: true,
                                 openfrom: 'brand',
                                 onKeyDown: (e) => {
                                    if (e.key === 'Enter') {
                                       e.preventDefault();
                                       categoryRef.current?.focus();
                                    }
                                 },
                              },
                              errors,
                              isDark ? '#94a3b8' : '#64748b',
                              true,
                              'Select Brand',
                              true,
                              undefined,
                              true,
                           )}
                        </FormControl>
                        <FormControl>
                           {renderDynamicDropdown(
                              'categoryid',
                              'Category',
                              categoryData,
                              {
                                 value: formData.categoryIds,
                                 onChange: handleCategoryChange,
                                 ref: categoryRef,
                                 showCustomNoOptions: true,
                                 openfrom: 'category',
                                 onKeyDown: (e) => {
                                    if (e.key === 'Enter') {
                                       e.preventDefault();
                                       seriesRef.current?.focus();
                                    }
                                 },
                              },
                              errors,
                              isDark ? '#94a3b8' : '#64748b',
                              true,
                              'Select Category',
                              true,
                              undefined,
                              true,
                           )}
                        </FormControl>
                     </Grid>
                     <FormControl>
                        {renderDynamicDropdown(
                           'seriesId',
                           'Series',
                           seriesData,
                           {
                              value: formData.seriesIds,
                              onChange: handleSeriesChange,
                              ref: seriesRef,
                              showCustomNoOptions: true,
                              openfrom: 'series',
                           },
                           errors,
                           isDark ? '#94a3b8' : '#64748b',
                           true,
                           'Select Series',
                           true,
                           undefined,
                           true,
                        )}
                     </FormControl>
                  </Box>
               </ModalBody>

               <Divider className={isDark ? 'border-slate-700' : 'border-gray-200'} />

               <ModalFooter
                  className={`
         ${isDark ? 'bg-slate-900' : 'bg-white'} 
         px-8 py-6 flex gap-3
      `}>
                  <Button
                     variant="ghost"
                     onClick={onClose}
                     className={`
               ${isDark ? 'text-slate-300 hover:bg-slate-800 hover:text-white' : 'text-gray-700 hover:bg-gray-100'}
               px-6 font-medium rounded-xl
            `}>
                     Cancel
                  </Button>
                  <Button
                     colorScheme="green"
                     onClick={handleSubmit}
                     isDisabled={!isFormValid}
                     className={`
               px-8 font-semibold rounded-xl shadow-lg
               ${!isFormValid
                           ? 'opacity-50 cursor-not-allowed'
                           : 'hover:shadow-xl transform hover:scale-105 transition-all duration-200'
                        }
            `}>
                     {isEditMode ? '💾 Update User' : '✨ Create User'}
                  </Button>
               </ModalFooter>
            </ModalContent>
         </Modal>

         <ManageUserRoleForm isOpen={isRoleModel} onClose={onCloseRoleModel} companyList={companyList} />
      </>
   );
};

export default AddUserModal;
